import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { useLanguage } from '../../../hooks/useLanguage';
import SubBanner from "../../../components/SubBanner";
import bannerImg from "../../../assets/img/about_bg.png";
import about_circle from "../../../assets/img/about_circle.png";
import about_2023 from "../../../assets/img/about_2023.png";
import about_2018 from "../../../assets/img/about_2018.png";
import about_2017 from "../../../assets/img/about_2017.png";
import trend_1 from '../../../assets/img/trend_1.png';
import { BOARD_LIST_URL } from "../../../utils/urls";
import instance from "../../../services/services";

function About(){
    const { t, currentLanguage } = useLanguage();
    // 0: 회사소개, 1: 오시는길, 2: 채용
    const [activeTab, setActiveTab] = useState(0);
    const [latestNewsList, setLatestNewsList] = useState([]);
    // 배너 탭
    const tabLabels = t('company.tab', []);
    const tabList = [
      { label: tabLabels[0], url: '/company/about' },
      { label: tabLabels[1], url: '/company/location' },
      { label: tabLabels[2], url: 'https://careers.nhn.com/' }
    ];

    const timelineTitles = t('sub_section_2.about.timeline', []);
    const timelineData = [
      { year: "2024", title: timelineTitles[0] },
      { year: "2023", title: timelineTitles[1], img: about_2023 },
      { year: "2022", title: timelineTitles[2] },
      { year: "2021", title: timelineTitles[3] },
      { year: "2019", title: timelineTitles[4] },
      { year: "2018", title: <span dangerouslySetInnerHTML={{__html: timelineTitles[5]}} />, img: about_2018 },
      { year: "2017", title: <span dangerouslySetInnerHTML={{__html: timelineTitles[6]}} />, img: about_2017 },
      { year: "2016", title: <span dangerouslySetInnerHTML={{__html: timelineTitles[7]}} /> },
      { year: "2015", title: <span dangerouslySetInnerHTML={{__html: timelineTitles[8]}} /> },
      { year: "2004", title: timelineTitles[9] }
    ];



    // 최신 소식 리스트
    useEffect(()=> {
      const fetchLatestNewsList = async () => {
        try{
          const response = await instance.post(BOARD_LIST_URL, {
            boardid: 'blog',
            offset: 1,
            limit: 4,
          })
          setLatestNewsList(response.data.data.data);
        } catch (error) {
          console.error('최신 소식 리스트 조회 오류:', error);
        }
      };
      fetchLatestNewsList();
    }, []);

    // 키워드를 태그 배열로 변환
    const getTagsFromKeyword = (keyword) => {
      if (!keyword) return [];
      return keyword.split(',').map(tag => `# ${tag.trim()}`);
    };



  return(
    <div className="company">
      {/* 배너 */}
      <SubBanner
        bgImg={bannerImg}
        bgPosition="center bottom"
        title= {tabLabels[0]}
        tabs={tabList.map((tab,idx) => ({
          label : tab.label,
          url : tab.url,
          active: activeTab === idx,
          onClick: () => setActiveTab(idx),
        }))}
        location={[
          { label: "Company", url: "/company" },
          { label: tabLabels[0], url: "/company/about", active: true }
        ]}
      />

      <section className="sub_section my-[120px] md:my-[160px] md:mt-[220px]  mx-auto">
        <div className="com_txt_box">
          <p dangerouslySetInnerHTML={{ __html: t('sub_section_1.about_title') }} />
        </div>
        <div className="mt-[50px] md:mt-[80px]">
          <figure className="m-auto">
            <img src={about_circle} alt="about_circle" loading="lazy"/>
          </figure>
        </div>
      </section>


      <section className="timeline_wrapper md:my-[160px] mx-auto md:py-[120px] bg_gray">
        <div className="sub_txt_box">
          <h3 className="f_40">{t('sub_section_2.about_title')}</h3>
          <span className="mt-[10px]">{t('sub_section_2.about_desc')}</span>
        </div>
        <div className="timeline">
          {timelineData.map((item, idx) => (
            <div 
              className={`timeline_item ${idx % 2 === 0 ? 'right' : 'left'}`}
              key={idx}
            >
              <div className="timeline_year">{item.year}</div>
              <div className="timeline_title">
                {typeof item.title === 'string'
                  ? item.title
                  : item.title /* <span dangerouslySetInnerHTML={{__html: ...}} /> 형태 */}
              </div>
              <div className="timeline_content">
                {item.img && (
                  <div className="timeline_img">
                    <img src={item.img} alt="연혁 이미지" />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {currentLanguage === 'ko' && (
        <section className="section_4 com_section my-[120px] mx-auto">
          <div className="sub_txt_box">
            <h3 className="f_40">NHN ACE 최신 소식</h3>
            <span className="mt-[10px]">NHN ACE에서 발행하는 최신 블로그 게시물입니다.</span>
          </div>
          <div className="com_more mt-[80px]">
            <Link to='/resources/blog'>
              더보기
              <i className="view_more"></i>
            </Link>
          </div>
          <div className='blog_grid'>
          {latestNewsList.map((blog, index) => (
            <div className='slide_item' key={blog.b_seq || index}>
              <Link to={`/resources/blog/blogDetail/${blog.b_seq}`}>
                  <div className='slide_top'>
                      <h4 className="ellipsis_2">
                          {blog.subject.split('\n').map((line, i) => (
                              <React.Fragment key={i}>
                                  {line}
                                  <br/>
                              </React.Fragment>
                          ))}
                      </h4>
                      <div className="ellipsis_2">
                          <ul>
                              {getTagsFromKeyword(blog.keyword).map((tag, i) => (
                                  <li key={i}>{tag}</li>
                              ))}
                          </ul>
                      </div>
                  </div>
                  <div className='slide_btm'>
                    <img
                      src={blog.main_image ? `https://admin.nhnace.com${blog.main_image}` : trend_1}
                      alt={blog.subject}
                      className="w-full h-full"
                    />
                </div>
              </Link>
            </div>
          ))}
            </div>
        </section>
      )}


    </div>
  )
}

export default About;